import React from "react";
import { Col, Row } from "antd";

import { i18, trb } from "@utilities";

export const PPPRowHeader = React.memo(() => {
  return (
    <Row className="mt-3 eb_fs_16">
      <Col span={4}>
        <b>{trb(i18.ApplicationsLabels.CheckDocumentName)}</b>
      </Col>
      <Col span={5} offset={1}>
        <b>{trb(i18.ApplicationsLabels.CheckDocumentMissingDocComment)}</b>
      </Col>
      <Col span={4} offset={1}>
        <b>{trb(i18.ApplicationsLabels.CheckDocumentMissingDocType)}</b>
      </Col>
      <Col span={5} offset={1}>
        <b>{trb(i18.ApplicationsLabels.CheckDocumentSelectMandatoryOptions)}</b>
      </Col>
      <Col span={2} offset={1} />
    </Row>
  );
});
